import file from './file'

export default
{
    file
};
